NtechApp.RecentNotificationsSelectList = function(nav) {
    var me = this;

    this._ajax = null;
    this._click = null;
    this._nav = null;

    this._notificationManager = null;

    this._loader = null;
    this._overlay = null;

    this._list = null;
    this._$itemsGrid = null;
    this._$itemsGridContent = null;
    this._$noNotificatonsItem = null;
    this._$seeAllItem = null;

    this._isLoaded = false;

    this._construct = function () {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._nav = nav;

        me._list = me._nav.getNotificationsSelectList();
        me._$itemsGrid = me._list.getWrapper().find("[data-itemsGrid]");
        me._$itemsGridContent = me._list.getWrapper().find("[data-itemsGridContent]");
        me._$noNotificationsItem = me._list.getWrapper().find("[data-noNotificationsItem]");
        me._$seeAllItem = me._list.getWrapper().find("[data-seeAllItem]");

        me._notificationManager = new NtechApp.NotificationManager(me._$itemsGrid);

        me._loader = new NtechApp.Loader(
            25, 25, "absolute", me._$itemsGridContent
        );
        me._overlay = new NtechApp.Overlay(
            me._$itemsGridContent,
            {position: "absolute"}
        );

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(me._nav).on(NtechApp.Nav.EVENT_SELECTLIST_NAV_ITEM_SELECT, function(e, itemName, item) {
            if(itemName == "notifications")
                me._saveMarkAllAsRead();

            if(me._isLoaded)
                return;

            if(itemName == "notifications")
                me._loadRecentNotificationsList(item);
        });

        me._click.listen(me._list.getWrapper(), "[data-closeTrigger]", function() {
            me._list.off();
        });
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.RecentNotificationsSelectList, {
    _loaderOn: function() {
        this._loader.on();
        this._overlay.on();
    },

    _loaderOff: function() {
        this._loader.off();
        this._overlay.off();
    },

    _getRecentNotificationsListRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_load_recent_notifications_list';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_load_recent_notifications_list';
    },

    _getMarkAllAsReadRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_notification_mark_all_as_viewed';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_notification_mark_all_as_viewed';
    },

    _saveMarkAllAsRead: function() {
        var me = this;

        me._ajax.get({
            url: Routing.generate(me._getMarkAllAsReadRoute()),
            onSuccess: function(data) {
                $(window).trigger(NtechApp.WINDOW_EVENTS.EVENT_NOTIFICATIONS_VIEWED);
            }
        });
    },

    _loadRecentNotificationsList: function(item) {
        this._loaderOn();
        var me = this;

        me._ajax.get({
            url: Routing.generate(me._getRecentNotificationsListRoute()),
            onSuccess: function(data) {
                me._$itemsGridContent.html($.parseHTML(data.html));
                me._updateNotificationsGrid(data.noNotifications, data.hasMoreNotifications);

                me._isLoaded = true;
                me._bindAjaxPollingUpdates();
            },
            onComplete: function() {
                me._loaderOff();
            }
        });
    },

    _updateNotificationsGrid: function(noNotifications, hasMoreNotifications) {
        var me = this;
        NtechApp.dateTools.convertDates(me._$itemsGridContent);

        if(noNotifications) {
            me._$noNotificationsItem.removeClass("hidden");
            me._$itemsGrid.addClass("hiddenGrid");
        }
        else {
            me._$itemsGrid.removeClass("hiddenGrid");
            me._$noNotificationsItem.addClass("hidden");
        }

        if(hasMoreNotifications)
            me._$seeAllItem.removeClass("hidden");
        else
            me._$seeAllItem.addClass("hidden");
    },

    _bindAjaxPollingUpdates: function() {
        var me = this;

        NtechApp.ajaxPolling.addPullRequestParamsResolver(function() {
            var $notifications = me._$itemsGridContent.find("[data-notificationModel]");
            var maxId = NtechApp.getMaxProp($notifications, "data-notificationModel");

            var params = {};
            if(maxId != 0) {
                params["pullSelectListNotifications"] = maxId;
            }
            else {
                params["pullAllSelectListNotifications"] = true;
            }

            params["pullSelectListNotificationsMarkAllAsViewed"] = (me._list.isOn()) ? 1 : 0;

            return params;
        });

        $(NtechApp.ajaxPolling).on(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, function(e, data) {
            if(!data.wasSelectListNotificationsUpdated)
                return;

            me._$itemsGridContent.find("[data-notificationModel]").remove();
            me._$itemsGridContent.append($.parseHTML(data.selectListNotificationsHtml));

            me._updateNotificationsGrid(data.noSelectListNotifications, data.hasMoreSelectListNotifications);
        });
    }
});